import styled from "styled-components";
import { default as BaseSelect } from "../../select/Select";
import {
  Input,
  Menu,
  Selected,
  SelectedItemInput
} from "../../select/styled/select";

export const Container = styled.form`
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;

  svg {
    margin-left: 1rem;
    fill: ${({ theme }) => theme.prevColors.streamsBlue};
  }
`;

export const Select = styled(BaseSelect)`
  border: 0;
  background-color: transparent;
  margin-top: 0.6rem;

  ${Selected} {
    padding: 0;
  }

  ${SelectedItemInput} {
    margin: 0;
  }

  ${Input} {
    ${({ theme }) => theme.inputs.base}
  }

  ${Menu} {
    margin-top: 0.4rem;
  }
`;

export const IndicatorLayout = styled.div`
  position: absolute;

  top: 1.2rem;
  right: 0.6rem;
`;
